import { Popover as PopoverPrimitive } from "@base-ui/react/popover";
import { cn, resolveClassName } from "./cn";

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverClose = PopoverPrimitive.Close;
export const PopoverTitle = PopoverPrimitive.Title;
export const PopoverDescription = PopoverPrimitive.Description;

export interface PopoverPopupProps extends PopoverPrimitive.Popup.Props {
  readonly side?: PopoverPrimitive.Positioner.Props["side"];
  readonly sideOffset?: PopoverPrimitive.Positioner.Props["sideOffset"];
  readonly align?: PopoverPrimitive.Positioner.Props["align"];
  readonly alignOffset?: PopoverPrimitive.Positioner.Props["alignOffset"];
  readonly popupClassName?: string;
}

export function PopoverPopup({
  className,
  popupClassName,
  children,
  side = "bottom",
  sideOffset = 6,
  align = "start",
  alignOffset = 0,
  ...props
}: PopoverPopupProps) {
  const defaultClasses = cn(
    "dropdown-glass min-w-48 overflow-hidden rounded-xl p-2 text-[var(--text)] shadow-[0_20px_48px_-16px_rgb(0_0_0/80%)] outline-none focus:outline-none",
    popupClassName,
  );

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Positioner
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
        className="z-[130] select-none"
      >
        <PopoverPrimitive.Popup className={resolveClassName(className, defaultClasses)} {...props}>
          {children}
        </PopoverPrimitive.Popup>
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  );
}
